<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.addAdd") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h2>
            {{ $t("PLACEHOLDERS.storeData") }}
          </h2>
          <base-select-input
            col="12"
            :optionsList="storeTypes"
            :placeholder="$t('PLACEHOLDERS.storeType')"
            v-model="storeType"
          />

          <div class="row" v-if="storeType?.value == 'external'">
            <base-image-upload-input
              col="12"
              identifier="admin_image"
              :placeholder="$t('PLACEHOLDERS.logo')"
              @selectImage="selectImage1"
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.store_name')"
              v-model.trim="data.storeName"
              required
            />
            <base-input
              col="6"
              type="text"
              :placeholder="$t('PLACEHOLDERS.website')"
              v-model.trim="data.website"
            />
            <base-input
              col="6"
              type="number"
              :placeholder="$t('PLACEHOLDERS.contactNum')"
              v-model.trim="data.contactNum"
              required
            />
          </div>
          <div v-if="storeType?.value == 'internal'">
            <base-select-input
              col="12"
              :optionsList="providers"
              :placeholder="$t('PLACEHOLDERS.stoerproviders')"
              v-model="provider"
            />
          </div>
          <h2>
            {{ $t("PLACEHOLDERS.offerData") }}
          </h2>
          <!-- Start:: Image Upload Input -->
          <div class="col-12">
            <div class="row align-items-center">
              <v-col col="12" sm="12" md="12">
                <UploadsPhotos
                  :urls="imgUrls"
                  multiple
                  @onFileSelect="onFileSelect"
                  @onFileRemove="onFileRemove"
                >
                  {{ $t("PLACEHOLDERS.AddImage") }}
                  <!-- {{ $t("PLACEHOLDERS.extendPhoto") }} -->
                  <!-- <span class="text-danger">*</span> -->
                </UploadsPhotos>
              </v-col>
            </div>
          </div>
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offerTitle')"
            v-model.trim="data.offerTitle"
            required
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.offerTitleEn')"
            v-model.trim="data.offerTitleEn"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.offerDesc')"
            v-model.trim="data.offerDesc"
            required
          />
          <base-input
            col="6"
            type="textarea"
            :placeholder="$t('PLACEHOLDERS.offerDescEn')"
            v-model.trim="data.offerDescEn"
            required
          />
          <!-- End:: Name Input -->
          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.startDate')"
            v-model.trim="data.startDate"
          />
          <base-picker-input
            col="6"
            type="date"
            :disabledDate="disabledDate"
            :placeholder="$t('PLACEHOLDERS.endDate')"
            v-model.trim="data.endDate"
          />
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import UploadsPhotos from "../../../components/formInputs/UploadsPhotos.vue";
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "CreateAdmin",
  components: {
    UploadsPhotos,
  },
  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data
      storeType: null,
      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        logo: {
          path: null,
          file: null,
        },
        storeName: null,
        website: null,
        contactNum: null,
        offerTitle: null,
        offerTitleEn: null,
        offerDesc: null,
        offerDescEn: null,
        startDate: null,
        endDate: null,
        areas: [],
        active: true,
      },
      additionalImages: [],
      imgUrls: [],
      allAreas: [],
      providers: [],
      provider: null,
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),

    storeTypes() {
      return [
        {
          id: 1,
          name: this.$t("PLACEHOLDERS.inSystem"),
          value: "internal",
        },
        {
          id: 2,
          name: this.$t("PLACEHOLDERS.Outdoor"),
          value: "external",
        },
      ];
    },
    // End:: Vuex Getters
  },

  methods: {
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    // Start:: Vuex Actions
    ...mapActions({
      getRoles: "ApiGetsModule/getRoles",
    }),
    // End:: Vuex Actions
    onFileSelect(files) {
      this.additionalImages = files;
    },
    onFileRemove(index) {
      this.$delete(this.imgUrls, index);
    },
    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    selectImage1(selectedImage) {
      this.data.logo = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // this.isValidEmail = emailRegex.test(this.data.email);
      // if (!this.isValidEmail) {
      //   this.isWaitingRequest = false;
      //   return;
      // }
      //this.$message.error(this.$t("VALIDATION.email_domain"));
      //
      // if (!this.data.name) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.name"));
      //   return;
      // }
      // else if (!this.data.email) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.email"));
      //   return;
      // }
      // else

      // if (!this.data.phone) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.mobileNumber"));
      //   return;
      // } else if (!this.data.password) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.password"));
      //   return;
      // } else if (this.data.password.length < 6) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.passwordLength"));
      //   return;
      // } else if (!this.data.passwordConfirmation) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.password"));
      //   return;
      // } else if (this.data.passwordConfirmation.length < 6) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.passwordLength"));
      //   return;
      // } else if (this.data.password != this.data.passwordConfirmation) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.notEqualPasswords"));
      //   return;
      // } else {
      this.submitForm();
      //   return;
      // }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      if (this.storeType && this.storeType.value == "internal") {
        if (this.provider.id) {
          REQUEST_DATA.append("vendor_id", this.provider?.id);
        }
      }

      if (this.storeType && this.storeType.value == "external") {
        if (this.data.storeName) {
          REQUEST_DATA.append("vendor_name", this.data.storeName);
        }
        if (this.data.logo.file) {
          REQUEST_DATA.append("vendor_logo", this.data.logo.file);
        }
        if (this.data.website) {
          REQUEST_DATA.append("website", this.data.website);
        }
        if (this.data.contactNum) {
          REQUEST_DATA.append("contact_number", this.data.contactNum);
        }
      }

      if (this.additionalImages && this.additionalImages.length > 0) {
        this.additionalImages.forEach((file, index) => {
          REQUEST_DATA.append(`images[${index}]`, file);
        });
      }
      if (this.data.offerTitle) {
        REQUEST_DATA.append("name[ar]", this.data.offerTitle);
      }
      if (this.data.offerTitleEn) {
        REQUEST_DATA.append("name[en]", this.data.offerTitleEn);
      }
      if (this.data.offerDesc) {
        REQUEST_DATA.append("description[ar]", this.data.offerDesc);
      }
      if (this.data.offerDescEn) {
        REQUEST_DATA.append("description[en]", this.data.offerDescEn);
      }

      REQUEST_DATA.append("is_active", +this.data.active);

      if (this.storeType && this.storeType?.value) {
        REQUEST_DATA.append("type", this.storeType?.value);
      }

      if (this.data.startDate) {
        REQUEST_DATA.append("from_date", this.data.startDate);
      }
      if (this.data.endDate) {
        REQUEST_DATA.append("to_date", this.data.endDate);
      }

      try {
        await this.$axios({
          method: "POST",
          url: `discount-platforms`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/discount_platforms/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    async getVendors() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `vendors?is_active=1&page=0&limit=0`,
        });
        // console.log("Cities =>", res.data.data);
        this.providers = res.data.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  async created() {
    this.getVendors();
    // Start:: Fire Methods
    // End:: Fire Methods
    this.$nextTick(() => {
      this.data.phone = "";
    });
  },
};
</script>
